import React, { useEffect, useState, useCallback } from "react";
import { Spin, Table, Card, Col, Row, Form, Select, Button } from "antd";
import { fetchAttendance } from "src/APIService/store";
import { ProductListingStyled } from "./styled";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

const AttendanceLog = () => {
  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stores, setStores] = useState([]); 
  const [selectedStores, setSelectedStores] = useState(null);

  const getAttendanceList = useCallback(async (merchantName = "") => {
    setLoading(true);
    try {
      const data = await fetchAttendance(merchantName);
      console.log("Attendance response:", data);
  
      setAttendanceData(data.attendances || []);
  
      if (!stores.length) {
        const uniqueStores = [
          ...new Set((data.attendances || []).map((item) => item.staff_merchant_name)),
        ].map((name) => ({ value: name, label: name }));
  
        setStores(uniqueStores);
      }
    } catch (error) {
      console.error("Failed to fetch attendance", error);
    } finally {
      setLoading(false);
    }
  }, [stores.length]);
  
  useEffect(() => {
    getAttendanceList();
  }, [getAttendanceList]);

  const handleSubmit = async () => {
    getAttendanceList(selectedStores || "");
  };

  const columns = [
    {
        title: "Staff Name",
        dataIndex: "staff_name",
        key: "staff_name",
    },
    {
        title: "Email",
        dataIndex: "staff_email",
        key: "staff_email",
    },
    {
        title: "Role",
        dataIndex: "staff_role",
        key: "staff_role",
    },
    {
        title: "Merchant",
        dataIndex: "staff_merchant_name",
        key: "staff_merchant_name",
    },
    {
        title: "Login Time",
        dataIndex: "staff_login_time",
        key: "staff_login_time",
        render: (text) => dayjs(text).format("DD-MM-YYYY HH:mm:ss"),
    },
    {
        title: "Logout Time",
        dataIndex: "staff_logout_time",
        key: "staff_logout_time",
        render: (text) => dayjs(text).format("DD-MM-YYYY HH:mm:ss"),
    },
    {
        title: "Total Working Hour",
        key: "total_working_hour",
        render: (_, record) => {
          const login = dayjs(record.staff_login_time);
          const logout = dayjs(record.staff_logout_time);
      
          if (!login.isValid() || !logout.isValid() || logout.isBefore(login)) {
            return "-";
          }
      
          const diffMs = logout.diff(login);
          const durationObj = dayjs.duration(diffMs);
      
          const hours = durationObj.hours();
          const minutes = durationObj.minutes();
      
          return `${hours} hour${hours !== 1 ? 's' : ''} ${minutes} minute${minutes !== 1 ? 's' : ''}`;
        },
    },
    {
        title: "Over Time Hours (Total Hours - 9)",
        key: "overtime_hour",
        render: (_, record) => {
          const login = dayjs(record.staff_login_time);
          const logout = dayjs(record.staff_logout_time);
    
          if (!login.isValid() || !logout.isValid() || logout.isBefore(login)) {
            return "-";
          }
    
          const diffMs = logout.diff(login);
          const durationObj = dayjs.duration(diffMs);
    
          const totalHours = durationObj.asHours();
    
          if (totalHours <= 9) return "00:00:00";
    
          const overtimeMs = diffMs - dayjs.duration(9, 'hours').asMilliseconds();
          const overtime = dayjs.duration(overtimeMs);
    
          const hours = String(Math.floor(overtime.asHours())).padStart(2, '0');
          const minutes = String(overtime.minutes()).padStart(2, '0');
          const seconds = String(overtime.seconds()).padStart(2, '0');
    
          return `${hours}:${minutes}:${seconds}`;
        },
    },
  ];

  return (
    <ProductListingStyled>
      <Card title="Attendance Log" className="product-listing-card">
        {loading ? (
          <Spin />
        ) : (
          <>
            <Row
              gutter={8}
              style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 24, paddingBottom: 10 }}
            >
              <Col className="gutter-row" xs={24} md={16} lg={12} xxl={8}>
                <Form onFinish={handleSubmit}>
                  <Row gutter={8}>
                    <Col span={24}>
                      <h4>Search</h4>
                    </Col>
                    <Col xs={12} md={12} lg={12} xxl={12}>
                      <Form.Item name="storeName">
                        <Select
                          showSearch
                          allowClear
                          options={stores}
                          placeholder="All"
                          onChange={(value) => setSelectedStores(value)}
                          filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(input.toLowerCase())
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={8} md={8} lg={8} xxl={8}>
                      <Form.Item>
                        <Button
                          block
                          type="primary"
                          htmlType="submit"
                          loading={loading}
                        >
                          Search
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>

            <div style={{ padding: 20 }}>
                <Table
                    scroll={{ x: "100%" }}
                    rowKey="id"
                    columns={columns}
                    dataSource={attendanceData}
                    pagination={false}
                />
            </div>
          </>
        )}
      </Card>
    </ProductListingStyled>
  );
};

export default AttendanceLog;
